import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Drawer,
  MenuItem,
  CircularProgress,
  InputLabel,
  Select,
  FormControl,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Link,
  Modal,
  TableContainer,
  TableCell,
  TableHead,
  Paper,
  Table,
  TableRow,
  TableBody,
  TextField,
  Grid,
} from "@mui/material";
import axios from "axios";
import Cookies from "js-cookie";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import EightSeater from "../../Assets/BoardRoom.png";
import EightSeater2 from "../../Assets/BoardRoom2.jpg";
import ThreeSeater from "../../Assets/3PAX.jpg";
import FourSeater from "../../Assets/4PAX1.jpg";
import FourSeater1 from "../../Assets/4PAX2.jpg";
import FourSeater2 from "../../Assets/4PAX3.png";
import FourSeater3 from "../../Assets/4PAX4.jpg";
import EightImage from "../../Assets/eightimage.png";
import { motion, AnimatePresence } from "framer-motion";
import Active_Bookings from "./Active_Bookings";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";



const Index = () => {
  const [selectedCabin, setSelectedCabin] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [startTime, setStartTime] = useState([]);
  const [loading, setLoading] = useState(true);
  const [slotdata, setSlotdata] = useState([]);
  const [open, setOpen] = useState(false);
  const [successmessage, setSuccessmessage] = useState("");
  const [successerr, setSuccesserr] = useState(false);
  const [activeBookings, setActiveBookings] = useState([]);
  const [bookingsdata, setBookingsdata] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedBookingId, setSelectedBookingId] = useState(null);
  const [cancelload, setcancelload] = useState(false);
  const [openn, setOpenn] = useState(false);
  const [eventname, setEventname] = useState("");
  const [credits, setCredits] = useState("");
  const [showcredits, setShowcredits] = useState(false);
  const [creditload, setCreditload] = useState(false);
  const [value, setValue] = useState(dayjs().format("YYYY-MM-DD"));
  const [location, setLocation] = useState("");


  const allCabins = {
    "4-Seater": [
      {
        id: 1,
        name: "Corellia",
        img: FourSeater,
        cabin_name: "corellia",
      },
      {
        id: 2,
        name: "Naboo",
        img: FourSeater1,
        cabin_name: "naboo",
      },
      {
        id: 3,
        name: "Alderaan",
        img: FourSeater2,
        cabin_name: "alderaan",
      },
      {
        id: 4,
        name: "Kashyyyk",
        img: FourSeater3,
        cabin_name: "kashyyyk",
      },
      {
        id: 5,
        name: "Bespin",
        img: FourSeater1,
        cabin_name: "bespin",
      },
    ],
    "8-Seater": [
      {
        id: 1,
        name: "Corusca",
        img: EightSeater,
        cabin_name: "coruscant",
      },
      {
        id: 2,
        name: "Tatooine",
        img: EightSeater2,
        cabin_name: "tatooine",
      },
    ],
    "3-Seater": [
      {
        id: 1,
        name: "Endor",
        img: ThreeSeater,
        cabin_name: "endor",
      },
    ],
  };

  const bangaloreCabins = {
    "4-Seater": [
      { id: 1, name: "Mandalore", img: FourSeater, cabin_name: "mandalore" },
      { id: 2, name: "Geonosis", img: FourSeater1, cabin_name: "geonosis" },
      { id: 3, name: "Vandor", img: FourSeater2, cabin_name: "vandor" },
    ],
  };

  const cabinImages = {
    "4-Seater": EightImage,
    "8-Seater": EightImage,
    "3-Seater": EightImage,
  };
  const cabins = location === "bangalore" ? bangaloreCabins : allCabins;

  const handleOpenn = () => {
    setOpenn(true);
    handleGetHistory();
  };
  const handleClosee = () => setOpenn(false);

  const handleOpenDialog = (bookingId) => {
    setSelectedBookingId(bookingId);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setSelectedBookingId(null);
  };
  const minDate = dayjs();
  const maxDate = dayjs().add(14, "day");
  const modalVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.5, ease: "easeOut" },
    },
    exit: { opacity: 0, scale: 0.8, transition: { duration: 0.5 } },
  };

  // Table row animation variants
  const rowVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, delay: i * 0.1 },
    }),
  };

  useEffect(() => {
    const token = Cookies.get("ssp_sso_token");
    if (!token) {
      window.location.href =
        "https://ssp.moreconnect.in/loginv2?source=slotify";
    }
  }, []);

  const handleGetHistory = async () => {
    try {
      const response = await axios.post(
        `https://api.more.in/v1/slotify`,
        { rawPath: "/complete_history"},
        {
          headers: {
            authorization: Cookies.get("ssp_sso_token"),
            "content-type": "application/json",
          },
        }
      );
      if (response?.data?.status == "success") {
        setBookingsdata(response?.data?.body?.history);
      } else {
        toast.error("View booking History Failed, Please try again later!", {
          position: "top-right",
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleGetCredits = async () => {
    setShowcredits(true);
    try {
      setCreditload(true);
      const response = await axios.post(
        `https://api.more.in/v1/slotify`,
        { rawPath: "/show_credit" },
        {
          headers: {
            authorization: Cookies.get("ssp_sso_token"),
            "content-type": "application/json",
          },
        }
      );
      if (response?.data?.status == "success") {
        setCredits(response?.data?.body?.data[0]?.remaining_credits);
        setCreditload(false);
      } else {
        setShowcredits(false);
        setCreditload(false);
        toast.error(
          response?.data?.body?.message ||
          "Something went wrong please try again later",
          { position: "top-right" }
        );
      }
    } catch (err) {
      console.log(err);
      setShowcredits(false);
      setCreditload(false);
      toast.error("Something went wrong please try again later", {
        position: "top-right",
      });
    }
  };

  const handleGetLocation = async () => {
    try {
      const response = await axios.post(
        `https://api.more.in/v1/slotify`,
        { rawPath: "/get_users_loc" },
        {
          headers: {
            authorization: Cookies.get("ssp_sso_token"),
            "content-type": "application/json",
          },
        }
      );
      if (response?.data?.status == "success") {
        setLocation(response?.data?.body?.location);
        setLoading(false);
      } else {
        setLoading(false);
        toast.error(
          response?.data?.body?.message ||
          "Something went wrong please try again later",
          { position: "top-right" }
        );
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
      toast.error("Something went wrong please try again later", {
        position: "top-right",
      });
    }
  }

  const handleCancelBooking = async (bookingId) => {
    try {
      setcancelload(true);
      const response = await axios.post(
        `https://api.more.in/v1/slotify`,
        { rawPath: "/cancel_booking", booking_id: selectedBookingId },
        {
          headers: {
            authorization: Cookies.get("ssp_sso_token"),
            "content-type": "application/json",
          },
        }
      );
      if (response?.data?.status == "success") {
        toast.success(
          response?.data?.body?.message || "Booking cancelled successfully",
          { position: "top-right" }
        );
        handleCloseDialog();
        handleGetHistory();
        handleGetCredits();
        setcancelload(false);
      } else {
        toast.error("Cancel booking failed, Please try again later!", {
          position: "top-right",
        });
        setcancelload(false);
      }
    } catch (error) {
      console.log(error);
      toast.error("Cancel booking failed, Please try again later!", {
        position: "top-right",
      });
      setcancelload(false);
    }
  };

  const handleCabinClick = (cabin) => {
    setSelectedCabin(cabin);
    setDrawerOpen(true);
    handleGetSlots(cabin);
    handleGetBookings(cabin);
  };

  const handleBooking = async () => {
    if (eventname == "") {
      toast.error("Event Name is mandatory", { position: "top-right" });
      return;
    }
    setLoading(true);
    try {
      const response = await axios.post(
        `https://api.more.in/v1/slotify`,
        {
          slot: startTime,
          cabin: selectedCabin?.cabin_name,
          event: eventname,
          booking_date: value,
          rawPath: "/save_booking"
        },
        {
          headers: {
            authorization: Cookies.get("ssp_sso_token"),
            "content-type": "application/json",
          },
        }
      );
      if (response?.data?.status == "success") {
        setSuccessmessage(
          response?.data?.body?.message || "Your booking has been confirmed"
        );
        setSuccesserr(true);
        setStartTime([]);
        handleGetBookings(selectedCabin);
        handleGetCredits();
        setEventname("");
        setLoading(false);
      } else {
        setSuccessmessage(
          response?.data?.body?.message ||
          "Cabin Booking failed. Please try again later!!"
        );
        setSuccesserr(false);
        setEventname("");
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setSuccessmessage("Cabin Booking failed. Please try again later!");
      setSuccesserr(false);
      setEventname("");
      setLoading(false);
    }
  };

  const handleMenuItemClick = (time) => {
    if (startTime.includes(time)) {
      // If already selected, remove it
      setStartTime(startTime.filter((item) => item !== time));
    } else {
      // If not selected, add it
      setStartTime([...startTime, time]);
    }
  };

  const handleChange = (event) => {
    // Sync startTime with Select's value to ensure consistency
    setStartTime(event.target.value);
  };

  const handleGetBookings = async (cabin) => {
    try {
      setLoading(true);
      const response = await axios.post(
        `https://api.more.in/v1/slotify`,
        {
          rawPath: "/active_booking_history",
          cabin_id: cabin?.cabin_name,
          booking_date: value,
        },
        {
          headers: {
            authorization: Cookies.get("ssp_sso_token"),
            "content-type": "application/json",
          },
        }
      );
      if (response?.data?.status === "success") {
        const updatedBookings = response?.data?.body?.history.map((booking) => {
          const endDate = new Date(booking.end);
          const startDate = new Date(booking.start);

          if (isNaN(endDate.getTime())) {
            console.error("Invalid end date:", booking.end);
            return { ...booking, end: booking.end }; // fallback
          }

          const endString = `new Date(${endDate.getFullYear()}, ${endDate.getMonth()}, ${endDate.getDate()}, ${endDate.getHours()}, ${endDate.getMinutes()}, ${endDate.getSeconds()})`;
          const startString = `new Date(${startDate.getFullYear()}, ${startDate.getMonth()}, ${startDate.getDate()}, ${startDate.getHours()}, ${startDate.getMinutes()}, ${startDate.getSeconds()})`;
          return {
            ...booking,
            end: endString,
            start: startString,
          };
        });

        setActiveBookings(updatedBookings);
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetCredits();
    handleGetLocation();
  }, []);

  const handleGetSlots = async (cabin) => {
    try {
      setLoading(true);
      const response = await axios.post(
        `https://api.more.in/v1/slotify`,
        { rawPath: "/get_booking_slots", cabin: cabin?.cabin_name, booking_date: value },
        {
          headers: {
            authorization: Cookies.get("ssp_sso_token"),
            "content-type": "application/json",
          },
        }
      );
      setSlotdata(response?.data?.body?.time);
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!selectedCabin) return;
    handleGetBookings(selectedCabin);
    handleGetSlots(selectedCabin);
  }, [value]);
  const isRestrictedCabin = ["coruscant", "tatooine"].includes(
    selectedCabin?.cabin_name
  );
  const allowedUsers = [
    "tushar.rane",
    "kalpana.prajapati",
    "priya.heda",
    "sareena.sanil",
    "harshal.more",
    "ankit.goel",
    "supratim.banerjee",
    "munawar.khan",
    "432589",
  ];
  const isAllowedUser = allowedUsers.includes(Cookies.get("ssp_domain_id"));

  return (
    <>
      <Box
        sx={{
          backgroundColor: "#EEF2F7",
          marginTop: "1rem",
        }}
      >
        <Box className="p-6 min-h-screen">
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box>
              <Typography variant="h4" className="mb-4 font-bold text-gray-800">
                Slotify
              </Typography>
              <Typography variant="subtitle1" className="mb-6 text-gray-600">
                Pick a cabin, set your time — just click to choose, and a
                sidebar will pop up to lock in your meeting.
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: 2,
              }}
            >
              <Box
                sx={{
                  p: 1,
                  border: "1px solid",
                  borderColor: "grey.300",
                  borderRadius: 4,
                  cursor: "pointer",
                }}
              >
                {creditload ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <CircularProgress size={20} />
                  </Box>
                ) : (
                  <Typography
                    variant="body1"
                    sx={{ whiteSpace: "nowrap", fontWeight: "bold" }}
                  >
                    Credits: {credits} left
                  </Typography>
                )}
              </Box>
              <Link
                onClick={handleOpenn}
                sx={{
                  color: "#1976D2",
                  textDecoration: "underline",
                  fontWeight: "bold",
                  fontSize: "1rem",
                  cursor: "pointer",
                  "&:hover": { color: "#1565C0" },
                }}
              >
                View Booking History
              </Link>
            </Box>
          </Box>
          <Modal
            open={openn}
            onClose={handleClosee}
            aria-labelledby="booking-history-modal"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <AnimatePresence>
              {openn && (
                <motion.div
                  variants={modalVariants}
                  initial="hidden"
                  animate="visible"
                  exit="exit"
                  style={{
                    backgroundColor: "#FFFFFF",
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
                    width: "60%",
                    maxHeight: "90vh",
                    overflowY: "auto",
                    padding: "24px",
                    position: "relative",
                  }}
                >
                  <IconButton
                    onClick={handleClosee}
                    sx={{
                      position: "absolute",
                      top: 16,
                      right: 16,
                      "&:hover": { backgroundColor: "#F5F7FA" },
                    }}
                    component={motion.div}
                    whileHover={{ scale: 1.1, rotate: 90 }}
                    transition={{ duration: 0.3 }}
                  >
                    <CloseIcon sx={{ color: "#555" }} />
                  </IconButton>
                  <Typography
                    id="booking-history-modal"
                    variant="h5"
                    sx={{ fontWeight: "bold", color: "#333", mb: 3 }}
                    component={motion.div}
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                  >
                    Booking History
                  </Typography>
                  {bookingsdata.length > 0 ? (
                    <Box sx={{ maxHeight: "60vh", overflowY: "auto" }}>
                      <TableContainer
                        component={Paper}
                        sx={{ boxShadow: "none" }}
                      >
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell
                                sx={{ fontWeight: "bold", color: "#333" }}
                              >
                                Cabin
                              </TableCell>
                              <TableCell
                                sx={{ fontWeight: "bold", color: "#333" }}
                              >
                                Date
                              </TableCell>
                              <TableCell
                                sx={{ fontWeight: "bold", color: "#333" }}
                              >
                                Time Slot
                              </TableCell>
                              <TableCell
                                sx={{ fontWeight: "bold", color: "#333" }}
                              >
                                Event
                              </TableCell>
                              <TableCell
                                sx={{ fontWeight: "bold", color: "#333" }}
                              >
                                Booked By
                              </TableCell>
                              <TableCell
                                sx={{ fontWeight: "bold", color: "#333" }}
                              >
                                Status
                              </TableCell>
                              <TableCell
                                sx={{ fontWeight: "bold", color: "#333" }}
                              ></TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {bookingsdata.map((booking, index) => (
                              <TableRow
                                key={booking.booking_id}
                                sx={{
                                  "&:hover": { backgroundColor: "#F5F7FA" },
                                }}
                                component={motion.tr}
                                custom={index}
                                variants={rowVariants}
                                initial="hidden"
                                animate="visible"
                              >
                                <TableCell>{booking.cabin_id}</TableCell>
                                <TableCell>{booking.booking_date}</TableCell>
                                <TableCell>{booking.time_slot}</TableCell>
                                <TableCell>{booking.event}</TableCell>
                                <TableCell>{booking.booked_by}</TableCell>
                                <TableCell>{booking.status}</TableCell>
                                <TableCell>
                                  {booking.is_deletable === "Y" && (
                                    <IconButton
                                      onClick={() =>
                                        handleOpenDialog(booking.booking_id)
                                      }
                                      sx={{ color: "red", ml: 1 }}
                                    >
                                      <CloseIcon
                                        sx={{ width: "16px", height: "16px" }}
                                      />
                                    </IconButton>
                                  )}
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                  ) : (
                    <Typography
                      sx={{ color: "#666", textAlign: "center", py: 4 }}
                      component={motion.div}
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{ duration: 0.5 }}
                    >
                      No bookings found.
                    </Typography>
                  )}
                </motion.div>
              )}
            </AnimatePresence>
          </Modal>
          <Box>
  {/* 4-Seater (and any other non-8/3 seater) */}
  {Object.keys(cabins)
    .filter((cat) => cat !== "8-Seater" && cat !== "3-Seater")
    .map((category) => (
      <Box key={category} className="mb-8">
        <Box sx={{ display: "flex", alignItems: "center" }} className="mb-4">
          <img
            src={cabinImages[category]}
            alt={`${category} icon`}
            className="w-8 h-8 mr-2 object-cover"
          />
          <Typography variant="h6" className="font-semibold text-gray-700">
            {category} Cabins
          </Typography>
        </Box>
        <Box className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
          {cabins[category].map((cabin) => (
            <Box
              key={cabin.id}
              className="bg-white rounded-lg shadow-md p-4 text-center hover:shadow-lg transition-shadow cursor-pointer"
              onClick={() => handleCabinClick(cabin)}
            >
              <img
                src={cabin.img}
                alt={cabin.name}
                className="w-full h-32 object-cover rounded-md mb-2"
              />
              <Typography variant="body1" className="font-medium text-gray-800">
                {cabin.name}
              </Typography>
              <Button
                variant="outlined"
                color="primary"
                className="mt-2"
                sx={{
                  fontWeight: "500",
                  textTransform: "none",
                  borderRadius: "8px",
                  padding: "6px 16px",
                }}
              >
                Book Now
              </Button>
            </Box>
          ))}
        </Box>
      </Box>
    ))}

  {/* 8-Seater + 3-Seater section — only render if they exist in cabins */}
  {(cabins["8-Seater"] || cabins["3-Seater"]) && (
    <>
      <Box
        sx={{
          height: "3px",
          width: "100%",
          backgroundColor: "#3B82F6",
          borderRadius: "3px",
          marginY: 4,
        }}
      />
      <Box sx={{ display: "flex", gap: 4 }} className="mb-8">
        {cabins["8-Seater"] && (
          <Box>
            <Box sx={{ display: "flex", alignItems: "center" }} className="mb-4">
              <img
                src={cabinImages["8-Seater"]}
                alt="8-Seater icon"
                className="w-8 h-8 mr-2 object-cover"
              />
              <Typography variant="h6" className="font-semibold text-gray-700">
                8-Seater Cabins
              </Typography>
            </Box>
            <Box className="grid grid-cols-2 gap-4">
              {cabins["8-Seater"].map((cabin) => (
                <Box
                  key={cabin.id}
                  className="bg-white rounded-lg shadow-md p-4 text-center hover:shadow-lg transition-shadow cursor-pointer"
                  onClick={() => handleCabinClick(cabin)}
                >
                  <img
                    src={cabin.img}
                    alt={cabin.name}
                    className="w-[17vw] h-32 object-cover rounded-md mb-2"
                  />
                  <Typography variant="body1" className="font-medium text-gray-800">
                    {cabin.name}
                  </Typography>
                  <Button
                    variant="outlined"
                    color="primary"
                    className="mt-2"
                    sx={{
                      fontWeight: "500",
                      textTransform: "none",
                      borderRadius: "8px",
                      padding: "6px 16px",
                    }}
                  >
                    Book Now
                  </Button>
                </Box>
              ))}
            </Box>
          </Box>
        )}

        {cabins["8-Seater"] && cabins["3-Seater"] && (
          <Box sx={{ width: "3px", backgroundColor: "#3B82F6" }} />
        )}

        {cabins["3-Seater"] && (
          <Box>
            <Box sx={{ display: "flex", alignItems: "center" }} className="mb-4">
              <img
                src={cabinImages["3-Seater"]}
                alt="3-Seater icon"
                className="w-8 h-8 mr-2 object-cover"
              />
              <Typography variant="h6" className="font-semibold text-gray-700">
                3-Seater Cabins
              </Typography>
            </Box>
            <Box className="grid grid-cols-1 gap-4">
              {cabins["3-Seater"].map((cabin) => (
                <Box
                  key={cabin.id}
                  className="bg-white rounded-lg shadow-md p-4 text-center hover:shadow-lg transition-shadow cursor-pointer"
                  onClick={() => handleCabinClick(cabin)}
                >
                  <img
                    src={cabin.img}
                    alt={cabin.name}
                    className="w-[17vw] h-32 object-cover rounded-md mb-2"
                  />
                  <Typography variant="body1" className="font-medium text-gray-800">
                    {cabin.name}
                  </Typography>
                  <Button
                    variant="outlined"
                    color="primary"
                    className="mt-2"
                    sx={{
                      fontWeight: "500",
                      textTransform: "none",
                      borderRadius: "8px",
                      padding: "6px 16px",
                    }}
                  >
                    Book Now
                  </Button>
                </Box>
              ))}
            </Box>
          </Box>
        )}
      </Box>
    </>
  )}
</Box>

          <Drawer
            anchor="left"
            open={drawerOpen}
            onClose={() => {
              setDrawerOpen(false);
              setSuccessmessage("");
            }}
          >
            <>
              {isRestrictedCabin && !isAllowedUser ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "100vh",
                    textAlign: "center",
                    px: 2,
                  }}
                >
                  <Typography variant="h6" color="error">
                    Booking not allowed, please contact office admin!
                  </Typography>
                </Box>
              ) : (
                <Box className="w-[40vw] p-6" sx={{ marginTop: "4rem" }}>
                  {loading ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "100vh",
                      }}
                    >
                      <CircularProgress color="inherit" />
                    </div>
                  ) : (
                    <>
                      <Typography
                        variant="h6"
                        className="mb-4 font-bold text-gray-800"
                      >
                        Book {selectedCabin?.name}
                      </Typography>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          label="Select Date"
                          value={dayjs(value)}
                          onChange={(newValue) => {
                            const formattedDate = newValue
                              ? newValue.format("YYYY-MM-DD")
                              : null;
                            setValue(formattedDate);
                            console.log("Selected date:", formattedDate);
                          }}
                          minDate={minDate}
                          maxDate={maxDate}
                          format="DD/MM/YYYY"
                          slotProps={{ textField: { fullWidth: true } }}
                          sx={{ mb: 2, width: "100%" }}
                        />
                      </LocalizationProvider>
                      <FormControl fullWidth className="mb-4">
                        <InputLabel id="start-time-label">
                          Time Slots
                        </InputLabel>
                        <Select
                          labelId="start-time-label"
                          label="Time Slots"
                          multiple={true}
                          value={startTime}
                          open={open}
                          onOpen={() => setOpen(true)}
                          onClose={() => setOpen(false)}
                          onChange={handleChange}
                          sx={{
                            fontWeight: "500",
                            textTransform: "none",
                            borderRadius: "8px",
                          }}
                          renderValue={(selected) => selected.join(", ")}
                        >
                          {slotdata.map((time) => (
                            <MenuItem
                              key={time}
                              value={time}
                              onClick={() => handleMenuItemClick(time)}
                              sx={{
                                // Style selected items to look "disabled" (grayed out)
                                backgroundColor: startTime.includes(time)
                                  ? "rgba(0, 0, 0, 0.12)"
                                  : "inherit",
                                color: startTime.includes(time)
                                  ? "rgba(0, 0, 0, 0.38)"
                                  : "inherit",
                                "&:hover": {
                                  backgroundColor: startTime.includes(time)
                                    ? "rgba(0, 0, 0, 0.2)"
                                    : "rgba(0, 0, 0, 0.04)",
                                },
                              }}
                            >
                              {time}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <TextField
                        className="mb-4"
                        fullWidth
                        label="Event Name"
                        onChange={(e) => setEventname(e.target.value)}
                        value={eventname}
                        sx={{
                          fontWeight: "500",
                          textTransform: "none",
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "8px",
                          },
                        }}
                      />
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor:
                            startTime.length > 0 && eventname !== ""
                              ? "#045EEF"
                              : "#A1C9FF",
                          color: "#FFFFFF",
                        }}
                        fullWidth
                        onClick={handleBooking}
                        disabled={
                          startTime.length > 0 && eventname !== ""
                            ? false
                            : true
                        }
                        sx={{
                          fontWeight: "500",
                          textTransform: "none",
                          borderRadius: "8px",
                          padding: "6px 16px",
                        }}
                      >
                        {loading ? "Saving..." : "Confirm Booking"}
                      </Button>
                    </>
                  )}
                  {successmessage == "" ? null : (
                    <Box
                      sx={{
                        backgroundColor: successerr ? "#d4e4d4" : "#FF7F7F",
                        color: successerr ? "#2f4f2f" : "#FFFFFF",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        border: successerr
                          ? "1px solid #d4e4d4"
                          : "1px solid #FF7F7F",
                        borderRadius: "8px",
                        fontFamily: "Arial, sans-serif",
                        fontSize: "16px",
                        padding: "12px",
                        minWidth: "200px",
                        minHeight: "100px",
                        width: "fit-content",
                        height: "fit-content",
                        maxWidth: "90vw",
                        boxSizing: "border-box",
                        wordBreak: "break-word",
                        marginTop: "1rem",
                      }}
                    >
                      {successmessage}
                    </Box>
                  )}
                  <Active_Bookings
                    activeBookings={activeBookings}
                    value={value}
                  />
                </Box>
              )}
            </>
          </Drawer>
        </Box>
        <Dialog
          open={dialogOpen}
          onClose={handleCloseDialog}
          aria-labelledby="cancel-booking-dialog"
          sx={{
            "& .MuiDialog-paper": {
              borderRadius: "12px",
              padding: "16px",
              backgroundColor: "#FFFFFF",
              boxShadow: "0 4px 16px rgba(0, 0, 0, 0.2)",
            },
          }}
        >
          <DialogTitle
            id="cancel-booking-dialog"
            sx={{
              fontFamily: "Roboto, sans-serif",
              fontSize: "18px",
              fontWeight: "600",
              color: "#333333",
            }}
          >
            Cancel Booking
          </DialogTitle>
          <DialogContent>
            <Typography
              sx={{
                fontFamily: "Roboto, sans-serif",
                fontSize: "14px",
                color: "#333333",
              }}
            >
              Are you sure you want to cancel this booking?
            </Typography>
          </DialogContent>
          {cancelload ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress color="inherit" />
            </div>
          ) : (
            <DialogActions>
              <Button
                onClick={handleCloseDialog}
                sx={{
                  color: "#008080",
                  fontWeight: "500",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "rgba(0, 128, 128, 0.1)",
                  },
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={() => handleCancelBooking(selectedBookingId)}
                sx={{
                  fontWeight: "500",
                  textTransform: "none",
                  borderRadius: "8px",
                  padding: "6px 16px",
                }}
                style={{ backgroundColor: "#FF0000", color: "#FFFFFF" }}
              >
                Confirm
              </Button>
            </DialogActions>
          )}
        </Dialog>
      </Box>
    </>
  );
};

export default Index;
